import { Offer, NameBanner } from '@rumblefish/ui/Rumblefish23Theme';
import { StyledStack, StyledSection, SectionNameBannerStack } from './styles';
import { ZKDevelopmentProcessData } from './ZKDevelopmentProcess.data';
import type { ZKDevelopmentProcessProps } from './ZKDevelopmentProcess.types';

export const ZKDevelopmentProcess = ({
  ...props
}: ZKDevelopmentProcessProps): React.ReactElement => {
  const customThresholds = [0, 32, 54, 70, 90];

  return (
    <>
      <StyledSection width="normal" id="zk-development-process">
        <StyledStack {...props}>
          <SectionNameBannerStack>
            <NameBanner
              type="section"
              text="ZK Development Process"
              color="teal"
            />
          </SectionNameBannerStack>
        </StyledStack>
      </StyledSection>
      <Offer
        title={ZKDevelopmentProcessData.mainText}
        description={ZKDevelopmentProcessData.description}
        data={ZKDevelopmentProcessData.services}
        height={'240px'}
        thresholds={customThresholds}
      />
    </>
  );
};
